<template>
  <div>
    <PageTitle :title="$t('global.order-ssl-certificate')" />
    <LoadingState v-if="!packages.status.isLoaded" :size="50" />
    <div v-else class="row">
      <div class="col-lg-8 pb-4">
        <Card :disable-title="true">
          <CertificateAddForm :on-change="onChange" :packages="packages" />
        </Card>
      </div>
      <div class="col-lg-4">
        <Card :disable-title="true" :height100="false">
          <CertificateAddSummary :summary="summary" />
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CertificateAddForm from "@/components/smart/forms/CertificateAddForm";
import CertificateAddSummary from "@/components/smart/cards/CertificateAddSummary";
import LoadingState from "@/components/display/LoadingState";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "CertificateAddPage",
  components: {
    Card,
    CertificateAddForm,
    CertificateAddSummary,
    LoadingState,
    PageTitle,
  },
  setup() {
    const summary = reactive({
      csr: false,
      package: {},
      source: false,
      domain: [],
    });
    const packages = computed(() => store.state.sslPackages);

    const onChange = (type, value) => {
      switch (type) {
        case "source":
          summary.source = value;
          break;
        case "package":
          summary.package = packages.value.list.find((pack) => pack.id === value);
          break;
        case "domain":
          summary.domain = value.split("\n").filter((domain) => domain !== "");
          break;
      }
    };

    onMounted(() => {
      store.dispatch("sslPackages/getList");
    });

    return {
      onChange,
      packages,
      summary,
    };
  },
};
</script>
